import PropTypes from 'prop-types';

import LogoCometeLink from './LogoCometeLink';
import LogoCometeClockings from './LogoCometeClockings';

const LogoApp = ({ sx }) => {
  const { isClockingApp } = window.env;

  if (isClockingApp) {
    return <LogoCometeClockings sx={sx} />;
  }

  return <LogoCometeLink sx={sx} />;
};
LogoApp.propTypes = {
  sx: PropTypes.object
};

export default LogoApp;
